<template>

    <div class="alert alert-sm alert-border-left alert-danger alert-dismissable" v-show="balance !== false && balance < 200">
        <i class="fa fa-info pr10"></i>
        <strong>Баланс SMSAERO {{balance}}!</strong> Надо пополнить на
        <a href="https://smsaero.ru/" target="_blank" class="alert-link">SMSAERO.ru</a>
    </div>

</template>

<script>
    import Sms from '../../../classes/api/Sms';

    export default {
        async beforeMount() {
            let response = await Sms.getBalance();
            this.balance = response.data.balance;
        },
        data() {
            return {
                balance: false
            };
        },
    };
</script>
